import { useContext } from 'react'
import { fontPickerOpenAtom, fontPickerPromiseAtom } from './atoms'
import { FontPickerStoreContext } from './store'
import type { FontSelection } from './types'

export function useFontPicker() {
	const store = useContext(FontPickerStoreContext)
	if (!store) {
		throw new Error('useFontPicker must be used within a FontPickerManager')
	}

	const open = (): Promise<FontSelection | undefined> => {
		return new Promise<FontSelection | undefined>((resolve, reject) => {
			// If a previous promise is pending, reject it
			const prev = store.get(fontPickerPromiseAtom)
			if (prev) {
				prev.reject(new DOMException('Font picker was re-opened by another caller', 'AbortError'))
			}

			store.set(fontPickerPromiseAtom, { resolve, reject })
			store.set(fontPickerOpenAtom, true)
		})
	}

	return { open }
}
